import "assets/scss/components/item.scss";
import React, { useState } from "react";
import { useApp } from "context";
import { Line } from "react-chartjs-2";
import { IAppointment } from "interfaces";
import { Custom } from "components";

//filler data
const labels = [
  "Mar 1",
  "Mar 2",
  "Mar 3",
  "Mar 4",
  "Mar 5",
  "Mar 6",
  "Mar 7",
  "Mar 8",
  "Mar 9",
  "Mar 10",
  "Mar 11",
  "Mar 12",
  "Mar 13",
  "Mar 14",
  "Mar 15",
  "Mar 16",
  "Mar 17",
  "Mar 18",
  "Mar 19",
  "Mar 20",
  "Mar 21",
  "Mar 22",
  "Mar 23",
  "Mar 24",
  "Mar 25",
  "Mar 26",
  "Mar 27",
  "Mar 28",
  "Mar 29",
  "Mar 30",
];

const datanumbers = [
  { date: "Mar 3", value: 10 },
  { date: "Mar 4", value: 5 },
];
const datanumbers2 = [
  { date: "Mar 3", value: 10 },
  { date: "Mar 4", value: 5 },
];
const datanumbers3 = [
  { date: "Mar 3", value: 10 },
  { date: "Mar 4", value: 5 },
];
const datanumbers4 = [
  { date: "Mar 3", value: 10 },
  { date: "Mar 4", value: 5 },
];
let label1 = "";
let label2 = "";
let label3 = "";
let label4 = "";

const getDate = (utcDateString: Date) => {
  const date = new Date(utcDateString);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const month2 = month.toString().padStart(2, "0");

  const day = date.getUTCDate();
  const day2 = day.toString().padStart(2, "0");
  return `${month2}-${day2}`;
};

function formatDate(date: Date, format: string): string {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  return format
    .replace("yyyy", year.toString())
    .replace("MM", month.toString().padStart(2, "0"))
    .replace("dd", day.toString().padStart(2, "0"))
    .replace("hh", hours.toString().padStart(2, "0"))
    .replace("mm", minutes.toString().padStart(2, "0"))
    .replace("ss", seconds.toString().padStart(2, "0"));
}

function processData(data: IAppointment[]) {
  datanumbers.length = 0;
  datanumbers2.length = 0;
  datanumbers3.length = 0;
  datanumbers4.length = 0;

  if (data[0]) {
    labels.length = 0;
    let oldDate = new Date(data[0].day);

    for (let i = 0; i < 30; i++) {
      const formattedDate = getDate(oldDate);
      labels.push(formattedDate);
      oldDate.setDate(oldDate.getDate() + 1);
    }
  }

  if (data) {
    for (let i = 0; i < data.length; i++) {
      let oldDate = new Date(data[i].day);

      const formattedDate = getDate(oldDate);

      switch (data[i].serviceId) {
        case 1:
          label1 = data[i].serviceName;
          const newData = {
            date: formattedDate.toString(),
            value: data[i].averageWaitingTime,
          };

          datanumbers.push(newData);

          break;
        case 2:
          label2 = data[i].serviceName;
          const newData2 = {
            date: formattedDate.toString(),
            value: data[i].averageWaitingTime,
          };

          datanumbers2.push(newData2);
          break;
        case 3:
          label3 = data[i].serviceName;
          const newData3 = {
            date: formattedDate.toString(),
            value: data[i].averageWaitingTime,
          };

          datanumbers3.push(newData3);

          break;
        case 4:
          label4 = data[i].serviceName;
          const newData4 = {
            date: formattedDate.toString(),
            value: data[i].averageWaitingTime,
          };

          datanumbers4.push(newData4);

          break;
      }
    }
  }
}

export const LineChart2 = () => {
  const { service } = useApp();
  const [data, setData] = useState<IAppointment[]>([]);
  React.useEffect(() => {
    const fetchData = async () => {
      const response = await service.appointment.getDataByUrl(
        "/appointment/stats/chart/m"
      );

      setData(response[1]);
    };

    fetchData();
  }, []);
  processData(data);

  return (
    <div>
      <Line
        data={{
          labels: labels,
          datasets: [
            {
              label: label1,
              data: datanumbers,
              fill: false,
              borderColor: "rgb(75, 192, 192)",
              tension: 0.1,
            },
            {
              label: label2,
              data: datanumbers2,
              fill: false,
              borderColor: "#1390D7",
              tension: 0.1,
            },
            {
              label: label3,
              data: datanumbers3,
              fill: false,
              borderColor: "#00519c",
              tension: 0.1,
            },
            {
              label: label4,
              data: datanumbers4,
              fill: false,
              borderColor: "#55afe2",
              tension: 0.1,
            },
          ],
        }}
        height={600}
        width={1000}
        options={{
          parsing: {
            xAxisKey: "date",
            yAxisKey: "value",
          },
          plugins: {
            tooltip: {
              enabled: true,
              mode: "index",
              intersect: false,
            },
            legend: {
              display: true,
            },
          },
          maintainAspectRatio: false,
          scales: {
            y: {
              title: {
                display: true,
                text: "Minutes",
              },
            },
            x: {
              title: {
                display: true,
                text: "Day",
              },
              ticks: {},
            },
          },
        }}
      ></Line>
    </div>
  );
};
